var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-linechart-wrap" }, [
    _vm.hasData
      ? _c("Line", {
          attrs: {
            "chart-options": _vm.chartOptions,
            "chart-data": _vm.chartData
          }
        })
      : _c("div", { staticClass: "ctm-linechart-empty" }, [
          _vm._v("No data to display")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }